<template>
  <template v-if="wins?.length">
    <div class="top-wins-slider-mobile section-gradient-wrapper">
      <div class="flex items-center">
        <div class="top-wins-slider-mobile__title section__title flex items-center">
          <icon name="top-wins" size="16" />
          {{ $t('topWins') }}
        </div>
        <router-link :to="{ name: 'top-wins' }" class="section__link cursor-pointer">
          {{ $t('all') }}
        </router-link>
      </div>

      <div class="top-wins-slider-mobile__items">
        <swiper v-bind="swiperOptions" @swiper="swiperRef = $event">
          <swiper-slide v-for="item in wins" :key="item" @click="checkSlide">
            <top-wins-game-item class="top-wins-game-item--swiper" :top-win="item" />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </template>
</template>

<script setup>
import TopWinsGameItem from './TopWinsGameItem.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref, computed, watch } from 'vue'
import { Autoplay } from 'swiper/modules'
import { useLazyQuery } from '@vue/apollo-composable'
import getBigWinsShort from 'src/apollo/queries/getBigWinsShort.gql'
import { useRoute } from 'vue-router'

const route = useRoute()

const swiperRef = ref(null)

const groupQuery = computed(() => route.params.group)

const variables = computed(() => {
  return {
    limit: 50,
    group: groupQuery.value ? groupQuery.value.toUpperCase() : null,
  }
})

const { result, load } = useLazyQuery(getBigWinsShort, variables, {
  fetchPolicy: 'cache-first',
})

watch(
  groupQuery,
  (newValue) => {
    if (route.name === 'Home' || route.name === 'GamesByGroup') {
      variables.value.group = newValue ? newValue.toUpperCase() : null

      load()
    }
  },
  {
    immediate: true,
  }
)

const wins = computed(() => result.value?.bigWin?.wins)

const swiperOptions = {
  loop: true,
  freeModeSticky: true,
  spaceBetween: 4,
  slidesPerView: 'auto',
  centeredSlides: true,
  autoplay: {
    delay: 5000,
  },
  modules: [Autoplay],
}

function checkSlide() {
  if (swiperRef.value.clickedIndex < swiperRef.value.activeIndex) {
    swiperRef.value.slidePrev()
  } else if (swiperRef.value.clickedIndex > swiperRef.value.activeIndex) {
    swiperRef.value.slideNext()
  }
}
</script>

<style lang="scss">
.top-wins-slider-mobile {
  color: white;

  &__title {
    gap: 8px;
  }

  &__items {
    margin: 0 -12px;
    width: calc(100% + 24px);

    .swiper-slide {
      width: 180px;
      flex-grow: 0;

      > * {
        transform: scale(0.77);
        opacity: 0.64;
        transition: all 0.4s;
      }

      @media screen and (min-width: 470px) {
        width: 320px;
      }
    }

    .swiper-slide-prev {
      > * {
        margin-left: 18px;
        transform: scale(0.77);

        @media screen and (min-width: 470px) {
          margin-left: 34px;
        }
      }
    }

    .swiper-slide-next {
      > * {
        margin-left: -18px;
        transform: scale(0.77);
        @media screen and (min-width: 470px) {
          margin-left: -34px;
        }
      }
    }

    .swiper-slide-active {
      > * {
        transform: scale(1) translateX(0);
        opacity: 1;
      }
    }
  }
}
</style>
